import { render } from "./App.vue?vue&type=template&id=f2a00eca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f2a00eca&lang=css"
script.render = render

export default script